module.exports = __webpack_public_path__ + "static/media/ai-math-popup-btn.b40515aa.png";